import { css, FlattenSimpleInterpolation, keyframes } from 'styled-components'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
  `
export const fadeInAnimation = (
  open: boolean,
): FlattenSimpleInterpolation => css`
  ${!open && `display: none;`}
  animation-name: ${fadeIn};
  animation-duration: 0.5s;
  animation-iteration-count: 1;
`
